import React, { useState } from 'react'

export default function LineUpHome() {
    const [Homerenk , Homesetrenk] = useState("#a41d34")
    const [Homerenk2 , Homesetrenk2] = useState("#14c0f1")
    const [Awayrenk , Awasetrenk] = useState("#163962")
    const [Awarenk2 , Awasetrenk2] = useState("#ffed00")
    const [lineStyle , setlineStyle] = useState("4-3-3")
  return (
    <div className='TeamsLineUpHome'>

    <div style={{gridTemplateColumns:"repeat(1, 1fr)"}} className='wrapperjersey'>
    <div className="container__inner">
   <div className="football-kit-teamsPage football-kit--stripes">
      <div style={{background: ` ${Homerenk} `}} className="football-kit__shirt-teamsPage">1</div>
      <div style={{ background: 	` ${Homerenk} `}} className="football-kit__stripes-teamsPage  football-kit__stripes--left"></div>
      <div style={{background: ` ${Homerenk} ` }} className="football-kit__stripes-teamsPage  football-kit__stripes--right"></div>
   </div>
   <div className='TeamsPageTeamPlayerName'>Uğurcan</div>
   </div>

    </div>
    <div style={{gridTemplateColumns:"repeat(1, 1fr)"}} className='wrapperjersey'>
    <div className="container__inner">
   <div className="football-kit-teamsPage football-kit--stripes">
      <div style={{background: ` ${Homerenk} `}} className="football-kit__shirt-teamsPage">33</div>
      <div style={{ background: 	` ${Homerenk} `}} className="football-kit__stripes-teamsPage  football-kit__stripes--left"></div>
      <div style={{background: ` ${Homerenk} ` }} className="football-kit__stripes-teamsPage  football-kit__stripes--right"></div>
   </div>
   <div className='TeamsPageTeamPlayerName'>Bruno Peres</div>
   </div>
   <div className="container__inner">
   <div className="football-kit-teamsPage football-kit--stripes">
      <div style={{background: ` ${Homerenk} `}} className="football-kit__shirt-teamsPage">3</div>
      <div style={{ background: 	` ${Homerenk} `}} className="football-kit__stripes-teamsPage  football-kit__stripes--left"></div>
      <div style={{background: ` ${Homerenk} ` }} className="football-kit__stripes-teamsPage  football-kit__stripes--right"></div>
   </div>
   <div className='TeamsPageTeamPlayerName'>M. Bartra</div>
   </div>
   <div className="container__inner">
   <div className="football-kit-teamsPage football-kit--stripes">
      <div style={{background: ` ${Homerenk} `}} className="football-kit__shirt-teamsPage">24</div>
      <div style={{ background: 	` ${Homerenk} `}} className="football-kit__stripes-teamsPage  football-kit__stripes--left"></div>
      <div style={{background: ` ${Homerenk} ` }} className="football-kit__stripes-teamsPage  football-kit__stripes--right"></div>
   </div>
   <div className='TeamsPageTeamPlayerName'>S. Denswill</div>
   </div>
   <div className="container__inner">
   <div className="football-kit-teamsPage football-kit--stripes">
      <div style={{background: ` ${Homerenk} `}} className="football-kit__shirt-teamsPage">18</div>
      <div style={{ background: 	` ${Homerenk} `}} className="football-kit__stripes-teamsPage  football-kit__stripes--left"></div>
      <div style={{background: ` ${Homerenk} ` }} className="football-kit__stripes-teamsPage  football-kit__stripes--right"></div>
   </div>
   <div className='TeamsPageTeamPlayerName'>E. Elmalı</div>
   </div>
   
    </div>
    <div style={{gridTemplateColumns:"repeat(1, 1fr)"}} className='wrapperjersey'>
    <div className="container__inner">
   <div className="football-kit-teamsPage football-kit--stripes">
      <div style={{background: ` ${Homerenk} `}} className="football-kit__shirt-teamsPage">6</div>
      <div style={{ background: 	` ${Homerenk} `}} className="football-kit__stripes-teamsPage  football-kit__stripes--left"></div>
      <div style={{background: ` ${Homerenk} ` }} className="football-kit__stripes-teamsPage  football-kit__stripes--right"></div>
   </div>
   <div className='TeamsPageTeamPlayerName'>Siopis</div>
   </div>
    </div>
    <div style={{gridTemplateColumns:"repeat(1, 1fr)"}} className='wrapperjersey'>
    <div className="container__inner">
   <div className="football-kit-teamsPage football-kit--stripes">
      <div style={{background: ` ${Homerenk} `}} className="football-kit__shirt-teamsPage">27</div>
      <div style={{ background: 	` ${Homerenk} `}} className="football-kit__stripes-teamsPage  football-kit__stripes--left"></div>
      <div style={{background: ` ${Homerenk} ` }} className="football-kit__stripes-teamsPage  football-kit__stripes--right"></div>
   </div>
   <div className='TeamsPageTeamPlayerName'>Trezeguet</div>
   </div>
   <div className="container__inner">
   <div className="football-kit-teamsPage football-kit--stripes">
      <div style={{background: ` ${Homerenk} `}} className="football-kit__shirt-teamsPage">11</div>
      <div style={{ background: 	` ${Homerenk} `}} className="football-kit__stripes-teamsPage  football-kit__stripes--left"></div>
      <div style={{background: ` ${Homerenk} ` }} className="football-kit__stripes-teamsPage  football-kit__stripes--right"></div>
   </div>
   <div className='TeamsPageTeamPlayerName'>Bakasetas</div>
   </div>
   <div className="container__inner">
   <div className="football-kit-teamsPage football-kit--stripes">
      <div style={{background: ` ${Homerenk} `}} className="football-kit__shirt-teamsPage">10</div>
      <div style={{ background: 	` ${Homerenk} `}} className="football-kit__stripes-teamsPage  football-kit__stripes--left"></div>
      <div style={{background: ` ${Homerenk} ` }} className="football-kit__stripes-teamsPage  football-kit__stripes--right"></div>
   </div>
   <div className='TeamsPageTeamPlayerName'>Abdulkadir</div>
   </div>
   <div className="container__inner">
   <div className="football-kit-teamsPage football-kit--stripes">
      <div style={{background: ` ${Homerenk} `}} className="football-kit__shirt-teamsPage">21</div>
      <div style={{ background: 	` ${Homerenk} `}} className="football-kit__stripes-teamsPage  football-kit__stripes--left"></div>
      <div style={{background: ` ${Homerenk} ` }} className="football-kit__stripes-teamsPage  football-kit__stripes--right"></div>
   </div>
   <div className='TeamsPageTeamPlayerName'>Djaniny</div>
   </div>
    </div>
    <div style={{gridTemplateColumns:"repeat(1, 1fr)"}} className='wrapperjersey'>
    <div className="container__inner">
   <div className="football-kit-teamsPage football-kit--stripes">
      <div style={{background: ` ${Homerenk} `}} className="football-kit__shirt-teamsPage">30</div>
      <div style={{ background: 	` ${Homerenk} `}} className="football-kit__stripes-teamsPage  football-kit__stripes--left"></div>
      <div style={{background: ` ${Homerenk} ` }} className="football-kit__stripes-teamsPage  football-kit__stripes--right"></div>
   </div>
   <div className='TeamsPageTeamPlayerName'>M. Gomez</div>
   </div>
    </div>
</div>
  )
}
